import React from 'react';
import FieldOptions from '@components/FieldOptions/FieldOptions';
import { StyledTooltipTitleWithIcon } from '@fabric-ui/components';
import { Badge, badgeClasses, BadgeProps, svgIconClasses, TooltipProps } from '@mui/material';

export type StyledBadgeBaseProps = Omit<BadgeProps, 'badgeContent'> & {
  tooltipProps?: Omit<TooltipProps, 'children'>;
  persistent?: boolean;
  enabledFieldTypesWithOptions?: Set<string | undefined>;
};

export type StyledBadgeProps = StyledBadgeBaseProps & { type?; selectedFields?; field?; onApply? };

export const StyledBadge = (props: StyledBadgeProps) => {
  const { current: id } = React.useRef(crypto.randomUUID());
  const { children, tooltipProps, persistent, enabledFieldTypesWithOptions, sx, ...rest } = props;

  return (
    <Badge
      sx={theme => ({
        [`& .${badgeClasses.badge}`]: {
          top: '50%',
          transform: 'scale(1) translate(0, -50%)',
          transformOrigin: '50% 0',
          cursor: 'pointer',
        },

        [`& .${svgIconClasses.root}`]: {
          opacity: persistent ? 1 : 0,
          transition: theme.transitions.create('opacity', { duration: theme.transitions.duration.shorter }),
          fontSize: 18,
        },

        [`& .${svgIconClasses.root} svg`]: StyledTooltipTitleWithIcon.iconStyles,
        [`:is([role=tooltip], &:hover) :is(& .${svgIconClasses.root}), 
          body:has([data-tooltip-id="${id}"]) & .${svgIconClasses.root}`]: {
          opacity: 1,
        },
        ...sx,
      })}
      badgeContent={
        <FieldOptions
          {...(props as any)}
          enabledFieldTypesWithOptions={enabledFieldTypesWithOptions}
          tooltipProps={tooltipProps && { ...tooltipProps, id }}
        />
      }
      {...rest}>
      {children}
    </Badge>
  );
};
